var render = function render(){var _vm=this,_c=_vm._self._c;return _c('content-preview',{attrs:{"id":_vm.id,"major_revision":_vm.major_revision,"minor_revision":_vm.minor_revision,"embeded_ip":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }